const STATISTIC_URL = `${window.location.pathname}/measurements`;

export default class Statistic {
  constructor(options = {}) {
    if (!options.fetcher) throw new Error('no Fetcher found');

    this.options = options;
    this.lastPage = false;
    this.signature = null;
    this.allViewedPromotions = [];
  }

  sendClick(promotionsIds) {
    if (!promotionsIds || !promotionsIds.length || !this.signature) {
      return Promise.resolve(true);
    }

    return this.options.fetcher({
      type: 'POST',
      url: STATISTIC_URL,
      body: JSON.stringify({
        data: {
          clicked: promotionsIds
        }
      }),
      headers: [
        { 'Content-type': 'application/json; charset=utf-8' },
        { 'Deals-metrics-signature': this.signature }
      ]
    });
  }

  addToView(viewedPromotions, isLastPage) {
    if (!viewedPromotions.length || this.lastPage || !this.signature) {
      return Promise.resolve(true);
    }

    const newIds = viewedPromotions.filter(
      (id) => !this.allViewedPromotions.includes(id)
    );

    if (!newIds.length) {
      return Promise.resolve(true);
    }

    return this.options
      .fetcher({
        type: 'POST',
        url: STATISTIC_URL,
        body: JSON.stringify({
          data: {
            viewed: newIds
          }
        }),
        headers: [
          { 'Content-type': 'application/json; charset=utf-8' },
          { 'Deals-metrics-signature': this.signature }
        ]
      })
      .then(() => {
        this.allViewedPromotions = [...this.allViewedPromotions, ...newIds];
        if (isLastPage) this.lastPage = true;
      });
  }

  sendWidgetView() {
    return this.options.fetcher({
      type: 'POST',
      url: STATISTIC_URL,
      body: JSON.stringify({
        data: {
          widget_view: 1
        }
      }),
      headers: [
        { 'Content-type': 'application/json; charset=utf-8' },
        { 'Deals-metrics-signature': this.signature }
      ]
    });
  }
}
